var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WeekChart',{attrs:{"title":_vm.title,"weekData":_vm.weekData,"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }